exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".linechart-wrapper{max-width:640px;width:100%;margin:0 auto}@media screen and (max-width:650px) .ui.dimmable.segment.padded padding 0px 10px div.lead padding 0px 10px", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/App.css
// module id = 132
// module chunks = 0